import React, { useState, useEffect } from 'react'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../utils/loading'
import { GetAssessmentMAndESelfForm2 } from '../../redux/actions/assessment'
import MAndESelfFormWidget from '../../widgets/assessment/MAndESelfFormWidget'
import { isEmpty } from 'lodash-es'
import { Col, FlexboxGrid, Grid, Row } from 'rsuite'

export default function MAndESelfFormUnauthorized() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  // const projectCode = sessionStorage.getItem('project_code')
  // const id = sessionStorage.getItem('m_e_s_id')

  const params = new URLSearchParams(window.location.search)
  const projectCode = params.get('code')
  const email = params.get('email')
  //const assessmentId = params.get('assId')
  //const preview = params.get('preview')

  useEffect(() => {
    if (isEmpty(projectCode) || isEmpty(email)) {
      setError({
        statusCode: 404,
        errorMessage: '- ไม่พบข้อมูล -',
      })
    } else {
      handleGetSchema(projectCode, email)
    }
  }, [projectCode, email])

  const handleGetSchema = async (projectCode, email) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await GetAssessmentMAndESelfForm2(projectCode, email)
      setSchema(response)
      // setSchema(mockSchema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
  }

  if (!schema || isLoading) {
    return <PanalLoadingTemplate />
  }

  return (
    <div>
      <FlexboxGrid>
        <FlexboxGrid.Item componentClass={Col} colspan={24} lg={4} md={2} smHidden xsHidden />
        <FlexboxGrid.Item componentClass={Col} colspan={24} lg={16} md={20}>
          <div className="content-header" style={{ marginTop: 20, textAlign: 'center' }}>
            <Row>
              <Col lg={24} md={24} sm={24} xs={24}>
                <h1>{schema.header}</h1>
              </Col>
            </Row>
            <hr />
          </div>
        </FlexboxGrid.Item>
        <FlexboxGrid.Item componentClass={Col} colspan={24} lg={4} md={2} smHidden xsHidden />

        <FlexboxGrid.Item componentClass={Col} colspan={24} lg={4} md={2} smHidden xsHidden />
        <FlexboxGrid.Item componentClass={Col} colspan={24} lg={16} md={20}>
          {schema.forms?.assessmentForm && (
            <MAndESelfFormWidget schema={schema.forms.assessmentForm} unauthen email={email} />
          )}
        </FlexboxGrid.Item>
        <FlexboxGrid.Item componentClass={Col} colspan={24} lg={4} md={2} smHidden xsHidden />
      </FlexboxGrid>

      {/* <Grid className="page-home">
        <div className="content-header" style={{ marginTop: 20, textAlign: 'center' }}>
          <Row>
            <Col lg={24} md={24} sm={24} xs={24}>
              <h1>{schema.header}</h1>
            </Col>
          </Row>
          <hr />
        </div>

        {schema.forms?.assessmentForm && (
          <MAndESelfFormWidget schema={schema.forms.assessmentForm} />
        )}
      </Grid> */}
    </div>
  )
}
